export default __webpack_public_path__ + "static/media/2433.fe45a773.png";